import { IState } from '../../store';
import { abUseExperimentsSelector, isAbUseExperimentsActive } from '../abUseExperiments';

export const WEB_3D_TOURS_EXPERIMENT = 'b2b_3d_tours_web';

export const selectIs3DToursExperimentActive = (state: IState): boolean => {
  const experiments = abUseExperimentsSelector(state);
  // эксперимент нацелен на группу = B
  const bGroup = isAbUseExperimentsActive(experiments, WEB_3D_TOURS_EXPERIMENT, 'B');

  return bGroup;
};
